import React, { useEffect, useState } from 'react';
import { PageCertificate } from '@scormhero/shared';

import styles from './Certificate.module.scss';
import ContainerPage from '../../UI/ContainerPage/ContainerPage';
import Button from '../../UI/Button/Button';
import Icon from '../../UI/Icon/Icon';
import Label from '../../context/Label/Label';
import CertificateModal from './CertificateModal';
import Alert from '../../UI/Alert/Alert';

type CertificatePageProps = PageCertificate & {
  globalState: any;
};

function Certificate(props: CertificatePageProps) {
  const { title, description, globalState } = props;
  const { onPageCompleted, courseCompleted, player } = globalState;
  const [showCertificate, setShowCertificate] = useState<boolean>(false);
  const canViewCertificate = courseCompleted || player?.editMode;

  useEffect(() => {
    onPageCompleted();
  }, []); // eslint-disable-line

  return (
    <ContainerPage
      className={styles.Certificate}
      title={title}
      globalState={globalState}
    >
      {showCertificate && (
        <CertificateModal
          onClickOutside={() => setShowCertificate(false)}
          {...props}
        />
      )}
      <div className={styles.Certificate__intro}>
        <Icon icon="award" className={styles.awardIcon} />
        {canViewCertificate ? (
          <p>{description}</p>
        ) : (
          <Alert warning>
            <Label>Visit all course pages to view the certificate.</Label>
          </Alert>
        )}
        <Button
          primary
          onClick={() => setShowCertificate(true)}
          globalState={globalState}
          disabled={!canViewCertificate}
        >
          <Label>view certificate</Label>
        </Button>
      </div>
    </ContainerPage>
  );
}

export default Certificate;
